// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SetCoverButton_wrapper__34BE5","wrapperSelected":"SetCoverButton_wrapperSelected__2ai3I"};